import { createFileRoute } from "@tanstack/react-router";
import { AjusteDeEstoquePage } from "@/paginas/ajuste-de-estoque";

export const Route = createFileRoute("/_authenticated/ajuste-de-estoque")({
  validateSearch: (s: Record<string, unknown>) => ({
    estoque: typeof s["estoque"] === "string" ? (s["estoque"] as string) : "",
  }),
  head: () => ({
    meta: [
      { title: "Ajuste de estoque — Milky Moo Palmares" },
      {
        name: "description",
        content: "Ajuste manual das quantidades do estoque selecionado.",
      },
      { property: "og:title", content: "Ajuste de estoque — Milky Moo Palmares" },
      {
        property: "og:description",
        content: "Ajuste manual das quantidades do estoque selecionado.",
      },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary" },
    ],
  }),
  component: AjusteDeEstoquePage,
});
